import axiosInstance from '../../../../config/axiosInstance';
const StockCategoryService = {
    async GetAllStckCategories(redirectCallback) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Setup/GetStockCategories?ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            if (error.response.data.message == "Invalid token") {
                redirectCallback();
                return;
            }
            console.error('Error fetching roles:', error);
            throw error;
        }
    },
    async DeleteStockCategory(ID, redirectCallback) {
        try {
            const response = await axiosInstance.get(`/Setup/DeleteStockCategory?ID=${ID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async SetDefaultStockCategory(ID, IsDefault, redirectCallback) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Setup/SetDefaultStockCategory?ID=${ID}&ClientID=${ClientID}&IsDefault=${IsDefault}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    }
    
};

export default StockCategoryService;